<template>
  <div class="text-center">
    <div v-if="compact" class="flex justify-center">
      <i class="fas fa-fw fa-spin fa-sync"></i>
    </div>
    <div v-else>
      <span class="block animated inline-block rounded-full" :class="fullClass"></span>
      <span class="block animated inverse inline-block rounded-full" :class="fullClass"></span>
      <span class="block animated inline-block rounded-full" :class="fullClass"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 50
    },
    fillColor: {
      type: String,
      required: false,
      default: 'grey-dark'
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    fullClass: function () {
      return `bg-${this.fillColor}`
    }
  }
}
</script>

<style lang="scss" scoped>
.animated {
  width: 15px;
  height: 15px;
  animation: loader-animated .5s linear infinite alternate;
  margin: 2px;
  &.inverse {
    animation-direction: alternate-reverse;
  }
}
@keyframes loader-animated {
  from {
    transform: scale(.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
